/**
 * @Author: Zewei
 * @Date:   2018-01-29T10:19:33+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-24T16:44:20+08:00
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchDepartmentsList, fetchDepartmentsInit, createNewDepartment, updateNewDepartment, createNewDepartmentEx,
  multiCreateDepartments, mergeDepartments, sequenceDepartments, deleteDepartment, fetchDepartmentDetail, updateDepartmentEx
} from '../../actions/department-structure-actions.js';
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
import {
  Table,
  Button,
  Modal,
  Spin,
  message,


  Divider,
  Form,
  Input,
  Select,
  Radio,

  Checkbox,

  InputNumber
} from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import './style.less';
// import DepartmentAddModal from '../../components/DepartmentStructure/DepartmentAddModal.js';
import DepartmentEditModal from '../../components/DepartmentStructure/DepartmentEditModal.js';
import DepartmentMoveModal from '../../components/DepartmentStructure/DepartmentMoveModal.js';
import { DepartmentStructureService } from '../../services/DepartmentStructure/department-structure-service.js';

const mapStateToProps = state => ({
  departmentStructure: state.departmentStructure,
  user: state.user.userInfo,
  employeeManagement: state.employeeManagement,
});
const mapDispatchToProps = {
  fetchDepartmentsList, fetchDepartmentsInit, createNewDepartment, updateNewDepartment,
  multiCreateDepartments, mergeDepartments, sequenceDepartments, deleteDepartment, fetchDepartmentDetail,
  fetchEmployeesList, createNewDepartmentEx, updateDepartmentEx
};

@connect(mapStateToProps, mapDispatchToProps)
class DepartmentStructure extends Component {
  state = {
    visible: false,
    editModalVisible: false,
    moveModalVisible: false,
    campus:1
  }

  componentDidMount() {
    this._fetchDepartmentsList()
    // this._fetchDepartmentsInit()
    if (this.props.access.departmentStructure.c_value || this.props.access.departmentStructure.u_value) {
      this._fetchEmployeesList()
    }
  }

  _fetchDepartmentsList = (params) => {
    this.props.fetchDepartmentsList(params)
  }
  _fetchDepartmentsInit = () => {
    this.props.fetchDepartmentsInit();
  }
  _fetchEmployeesList = () => {
    this.props.fetchEmployeesList()
  }

  handleOpenCreateNewModal = (record) => {
    this._fetchDepartmentsInit()
    this.setState({ parent_id: record.id });
    this.props.createNewDepartmentEx({}, status => {
      if (status) {
        let dailyReport = [], weeklyReport = [], monthlyReport = [];
        this.props.departmentStructure.reportList.forEach(report => {
          switch (report.type_id) {
            case 1:
              dailyReport.push({ id: report.id, name: report.name, type_id: report.type_id });
              break;
            case 2:
              weeklyReport.push({ id: report.id, name: report.name, type_id: report.type_id });
              break;
            case 3:
              monthlyReport.push({ id: report.id, name: report.name, type_id: report.type_id });
              break;
            default:

          }
        });
        this.setState({
          name: null,
          authorized_strength: 1,
          charge_user_id: '',
          charge_user_name: '',
          charge_user_id_2: '',
          charge_user_name_2: '',
          charge_user_id_3: '',
          charge_user_name_3: '',
          dailyReportTemplate: dailyReport,
          weeklyReportTemplate: weeklyReport,
          monthlyReportTemplate: monthlyReport,
          selectDailyReport: false,
          selectWeeklyReport: false,
          selectMonthlyReport: false,
          currentDailyReportTemplate: dailyReport ? dailyReport[0].id : null,
          currentWeeklyReportTemplate: weeklyReport ? weeklyReport[0].id : null,
          currentMonthlyReportTemplate: monthlyReport ? monthlyReport[0].id : null
        }, () => {
          this.setState({ visible: true, currentIndex: null });
        });
      } else {
        message.error("请求数据错误", 4);
      }
    });
  }
  handleEdit = (record, isDisabled) => {
    this._fetchDepartmentsInit()
    // console.log(record);
    this.setState({ department_id: record.id });
    this.props.updateDepartmentEx({ department_id: record.id }, () => {
      console.log(this.props.departmentStructure.initUpdateData);
      let dailyReport = [], weeklyReport = [], monthlyReport = [];
      this.props.departmentStructure.initUpdateData.templates.forEach(report => {
        switch (report.type_id) {
          case 1:
          case 2:
            dailyReport.push({ id: report.id, name: report.name, type_id: report.type_id });
            break;
          case 3:
            weeklyReport.push({ id: report.id, name: report.name, type_id: report.type_id });
            break;
          case 4:
            monthlyReport.push({ id: report.id, name: report.name, type_id: report.type_id });
            break;
          default:
        }
      });

      let department = this.props.departmentStructure.initUpdateData.department;
      let currentDailyReportTemplate = 0
        , currentWeeklyReportTemplate = 0
        , currentMonthlyReportTemplate = 0;
      department.department_templates.forEach(template => {
        switch (template.type_id) {
          case 1:
          case 2:
            currentDailyReportTemplate = template.template_id;
            break;
          case 3:
            currentWeeklyReportTemplate = template.template_id;
            break;
          case 4:
            currentMonthlyReportTemplate = template.template_id;
            break;
          default:
        }
      });
      this.setState({
        name: department.name,
        campus:department.campus,
        authorized_strength: department.authorized_strength,
        charge_user_id: department.charge_user_id,
        charge_user_name: department.charge_user_name ? department.charge_user_name : "",
        charge_user_id_2: department.charge_user_id_2,
        charge_user_name_2: department.charge_user_name_2 ? department.charge_user_name_2 : "",
        charge_user_id_3: department.charge_user_id_3,
        charge_user_name_3: department.charge_user_name_3 ? department.charge_user_name_3 : "",
        dailyReportTemplate: dailyReport,
        weeklyReportTemplate: weeklyReport,
        monthlyReportTemplate: monthlyReport,
        selectDailyReport: department.write_daily_report,
        selectWeeklyReport: department.write_weekly_report,
        selectMonthlyReport: department.write_monthly_report,
        currentDailyReportTemplate: currentDailyReportTemplate,
        currentWeeklyReportTemplate: currentWeeklyReportTemplate,
        currentMonthlyReportTemplate: currentMonthlyReportTemplate,
        visible: true,
        currentIndex: 1
      }, () => console.log(this.state));
    });
  }


  // 真实 提交 编辑当前部门的操作
  handleUpdate = () => {
    const form = this.editForm;
    const { currentEditRecord } = this.state;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      let payload = {
        ...values,
        id: currentEditRecord.id,
        sequence: currentEditRecord.sequence,
        parent_id: currentEditRecord.parent_id,
        authorized_strength: currentEditRecord.authorized_strength,
      }
      this.props.updateNewDepartment(payload)
      form.resetFields()
      this.setState({ editModalVisible: false })
    });
  }
  handleCancel = () => {
    this.setState({
      visible: false
    })
  }
  handleCreateNew = () => {
    const form = this.form;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      console.log(values)
      this._formatFormDate(values)
      form.resetFields()
      this.setState({ visible: false })
    });
  }
  _formatFormDate = (values) => {
    // 每行有5个字段
    const rowNum = 5;
    let { record } = this.state,
      formDataArr = [],
      formFieldData = {},
      indexNum = 0,
      valuesKeys = Object.keys(values),
      length = valuesKeys.length;
    // 递归调用该 recursive 函数 循环 导出 最终 post 的 data
    let recursive = () => {
      let flag = 0;
      valuesKeys.forEach((item, index) => {
        let strIndex = item.indexOf(`_${indexNum}`);
        if (strIndex !== -1) {
          flag++;
          let newKey = item.substring(0, strIndex);
          formFieldData[newKey] = values[item];
          if (flag === rowNum) {
            if (formFieldData.name) {
              formFieldData['charge_user_id'] = formFieldData['charge_user_id']
              // formFieldData['charge_user_id'] = Number(formFieldData['charge_user_id'])
              formFieldData['parent_id'] = record.id;
              formFieldData['sequence'] = record.sequence;
              formFieldData['authorized_strength'] = record.authorized_strength;

              formDataArr.push(formFieldData);
            }
            formFieldData = {};
            indexNum++;
            if (indexNum < length - 1) {
              recursive()
            } else {
              return
            }
          }
        }
      })
    }
    recursive()
    this.props.multiCreateDepartments({ Departments: formDataArr });
  }

  saveFormRef = (form) => {
    this.form = form;
  }
  saveEditFormRef = (form) => {
    this.editForm = form;
  }

  handleDelete = (record) => {
    Modal.confirm({
      title: '确定删除?',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        let data = { id: record.id };
        this.props.deleteDepartment(data);
      },
      onCancel: () => { }
    });
  }

  handleCancelEditModal = () => {
    this.setState({
      editModalVisible: false
    })
  }
  handleCancelMoveModal = () => {
    this.setState({
      moveModalVisible: false
    })
  }
  handleMove = (id) => {
    this.setState({
      moveModalVisible: true,
      currentMoveId: id
    })
  }
  handleMoveDepartment = () => {
    let state = this.state,
      payload = {
        CurrentId: state.currentMoveId,
        TargetId: state.targetMoveId[0]
      }
    this.props.mergeDepartments(payload)
    this.setState({
      moveModalVisible: false
    })
  }
  onSelectTreeNode = (id) => {
    this.setState({
      targetMoveId: id
    })
  }

  sortDepartments = (record, bool, index) => {
    let payload = {
      id: record.id,
      is_asc: bool
    }
    this.props.sequenceDepartments(payload)
  }

  componentWillReceiveProps(nextProps) {
    const { departmentStructure } = nextProps;
    departmentStructure.actionStatus && this._fetchDepartmentsList();
  }
  // 供 AutoComplete 使用
  handleSearch = (v) => {
    console.log(v)
    let params = { real_name: v };
    this.props.fetchEmployeesList(params)
  }

  setSelectDailyReport = () => {
    if (!this.state.selectDailyReport) {
      this.setState({ currentDailyReportTemplate: this.state.dailyReportTemplate[0].id });
    }
    this.setState({ selectDailyReport: !this.state.selectDailyReport });
  }

  setDailyReportTemplate = templateID => {
    console.log(templateID);
    this.setState({ currentDailyReportTemplate: templateID });
  }

  setSelectWeeklyReport = () => {
    if (!this.state.selectWeeklyReport) {
      this.setState({ currentWeeklyReportTemplate: this.state.weeklyReportTemplate[0].id });
    }
    this.setState({ selectWeeklyReport: !this.state.selectWeeklyReport });
  }
  setWeeklyReportTemplate = templateID => {
    console.log(templateID);
    this.setState({ currentWeeklyReportTemplate: templateID });
  }

  setSelectMonthlyReport = () => {
    if (!this.state.selectMonthlyReport) {
      this.setState({ currentMonthlyReportTemplate: this.state.monthlyReportTemplate[0].id });
    }
    this.setState({ selectMonthlyReport: !this.state.selectMonthlyReport });
  }
  setMonthlyReportTemplate = templateID => {
    console.log(templateID);
    this.setState({ currentMonthlyReportTemplate: templateID });
  }

  submitDepartment = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log(values);
        console.log(this.state);
        let posts = {
          name: values.name,
          authorized_strength: values.authorized_strength,
          parent_id: this.state.parent_id,
          campus:values.campus,
          charge_user_id: this.state.charge_user_id,
          charge_user_id_2: this.state.charge_user_id_2,
          charge_user_id_3: this.state.charge_user_id_3,
          write_daily_report: !!values.write_daily_report,
          write_weekly_report: !!values.write_weekly_report,
          write_monthly_report: !!values.write_monthly_report,
          department_templates: []
        }
        if (posts.write_daily_report) {
          let dailyReportTemplate = {};
          this.state.dailyReportTemplate.forEach(template => {
            if (this.state.currentDailyReportTemplate === template.id) {
              dailyReportTemplate = { ...template, template_id: template.id };
            }
          });
          if (this.state.department_id) {
            dailyReportTemplate.department_id = this.state.department_id;
          }
          posts.department_templates.push(dailyReportTemplate);
        }
        if (posts.write_weekly_report) {
          let weeklyReportTemplate = {};
          this.state.weeklyReportTemplate.forEach(template => {
            if (this.state.currentWeeklyReportTemplate === template.id) {
              weeklyReportTemplate = { ...template, template_id: template.id };
            }
          });
          if (this.state.department_id) {
            weeklyReportTemplate.department_id = this.state.department_id;
          }
          posts.department_templates.push(weeklyReportTemplate);
        }
        if (posts.write_monthly_report) {
          let monthlyReportTemplate = {};
          this.state.monthlyReportTemplate.forEach(template => {
            if (this.state.currentMonthlyReportTemplate === template.id) {
              monthlyReportTemplate = { ...template, template_id: template.id };
            }
          });
          if (this.state.department_id) {
            monthlyReportTemplate.department_id = this.state.department_id;
          }
          posts.department_templates.push(monthlyReportTemplate);
        }

        console.log(JSON.stringify(posts));

        if (null === this.state.currentIndex) {
          DepartmentStructureService.addDepartmentEx(posts, res => {
            if (res.data.Success) {
              message.success("创建部门成功", 4);
              this.setState({ visible: false });
              this.props.fetchDepartmentsList();
            } else {
              message.error("创建部门失败 " + res.data.Errors[0], 4);
            }
          })
        } else {
          posts.id = this.state.department_id;
          console.log(JSON.stringify(posts));
          DepartmentStructureService.updateDepartmentActionEx(posts, res => {
            console.log(res);
            if (res.data.Success) {
              message.success("修改部门成功", 4);
              this.setState({ visible: false });
              this.props.fetchDepartmentsList();
            } else {
              message.error("修改部门失败 " + res.data.Errors[0], 4);
            }
          });
        }
      }
    });
  }

  changeChargeUser = value => {
    let param = {
      real_name: value
    }
    this.props.fetchEmployeesList(param);
  }

  selectChargeUser = (name, obj) => {
    this.setState({
      charge_user_id: obj.props.data,
      charge_user_name: name
    });
  }

  changeChargeUser2 = value => {
    let param = {
      real_name: value
    }
    this.props.fetchEmployeesList(param);
  }

  selectChargeUser2 = (name, obj) => {
    this.setState({
      charge_user_id_2: obj.props.data,
      charge_user_name_2: name
    });
  }

  changeChargeUser3 = value => {
    let param = {
      real_name: value
    }
    this.props.fetchEmployeesList(param);
  }

  selectChargeUser3 = (name, obj) => {
    this.setState({
      charge_user_id_3: obj.props.data,
      charge_user_name_3: name
    });
  }
  render() {
    // const { users, departmentDetail, expandedRowKey } = this.props.departmentStructure;
    // const departmentsList = JSON.parse(JSON.stringify(this.props.departmentStructure.departmentsList))

    // // const { departmentsList, users, departmentDetail, expandedRowKey } = this.props.departmentStructure;
    // const { employeeList } = this.props.employeeManagement;
    // const { visible, editModalVisible, moveModalVisible, isDisabled } = this.state;
    // const treeDeleteEmptyArray = data => {
    //   if (data.children){
    //     if (data.children.length === 0) {
    //       delete data.children;
    //     }else{
    //       // console.log(data.children);
    //       data.children.forEach(child => treeDeleteEmptyArray(child))
    //     }
    //   }

    // }
    // if (departmentsList && departmentsList[0]) {
    //   treeDeleteEmptyArray(departmentsList[0]);
    // }
    const { users, departmentDetail, expandedRowKey } = this.props.departmentStructure;
    const { employeeList } = this.props.employeeManagement;
    const { visible, editModalVisible, moveModalVisible, isDisabled } = this.state;
    const treeDeleteEmptyArray = data => {
      if (data.children) {
        if (data.children.length === 0) {
          delete data.children;
        } else {
          // console.log(data.children);
          data.children.forEach(child => treeDeleteEmptyArray(child))
        }
      }

    }
    let { departmentsList } = this.props.departmentStructure;
    if (departmentsList && departmentsList[0]) {
      departmentsList = JSON.parse(JSON.stringify(departmentsList));
      treeDeleteEmptyArray(departmentsList[0]);
    }

    const columns = [{
      title: '部门层级',
      dataIndex: 'name',
      key: 'name'
    }, {
      title: '在职',
      dataIndex: 'on_the_job_count',
      key: 'on_the_job_count',
    }, {
      title: '编制',
      dataIndex: 'authorized_strength',
      key: 'authorized_strength',
    }, {
      title: '部门主管',
      dataIndex: 'charge_user_name',
      key: 'charge_user_name',
    }, {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      render: (text, record, index) => (
        <span>
          {
            record.parent_id === null ?
              <div>
                {this.props.access.departmentStructure.c_value && <Button size="small" icon="plus" onClick={this.handleOpenCreateNewModal.bind(this, record)} type="primary" className="buttonGap">新增一级部门</Button>}
                {this.props.access.departmentStructure.u_value && <Button size="small" type="primary" className="buttonGap" onClick={this.handleEdit.bind(this, record, true)}>编辑</Button>}
              </div>
              :
              <div>
                {this.props.access.departmentStructure.u_value && <Button size="small" className="buttonGap" shape="circle" disabled={record.sequence === 1 ? true : false} icon="arrow-up" onClick={this.sortDepartments.bind(this, record, true, index)} />}
                {this.props.access.departmentStructure.u_value && <Button size="small" className="buttonGap" shape="circle" icon="arrow-down" onClick={this.sortDepartments.bind(this, record, false, index)} />}
                {this.props.access.departmentStructure.c_value && <Button size="small" icon="plus" onClick={this.handleOpenCreateNewModal.bind(this, record)} className="buttonGap">新增子部门</Button>}
                {this.props.access.departmentStructure.move_value && <Button size="small" className="buttonGap" onClick={this.handleMove.bind(this, record.id)}>合并</Button>}
                {this.props.access.departmentStructure.u_value && <Button size="small" className="buttonGap" onClick={this.handleEdit.bind(this, record, false)}>编辑</Button>}
                {this.props.access.departmentStructure.d_value && <Button size="small" className="buttonGap" onClick={this.handleDelete.bind(this, record)}>删除</Button>}
              </div>
          }
        </span>
      ),
    }];

    return (
      <div className="app-module-item">
        <div className="colAction">
          <Divider />
        </div>
        {
          departmentsList ?
            <Table
              columns={columns}
              defaultExpandedRowKeys={expandedRowKey}
              dataSource={departmentsList}
              rowKey={record => `${record.id}`}
              scroll={{ x: 1000 }}
            />
            :
            <Spin size="large" className="spin-center" />
        }
        {/* 新增部门 modal 弹窗 */}
        {
          <Modal width="800px" visible={visible}
            title="部门"
            handleCancel={this.handleCancel}
            onCancel={this.handleCancel}
            destroyOnClose={true}
            onOk={this.submitDepartment}>
            <div style={{ textAlign: "center", margin: "0px 0px 5px", maxHeight: "600px", overflowY: "auto" }}>
              <Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
                <div>
                  <Form.Item label="部门名称">
                    {this.props.form.getFieldDecorator('name', {
                      rules: [{ required: true, message: '请输入部门名称' }],
                      initialValue: this.state.name
                    })(<Input style={{ width: "300px" }} />)}
                  </Form.Item>
                </div>
                <div style={{ paddingLeft: "9px" }}>
                  <Form.Item label="部门人数">
                    {this.props.form.getFieldDecorator('authorized_strength', {
                      rules: [{ required: true, message: '请输入部门人数' }],
                      initialValue: this.state.authorized_strength
                    })(<InputNumber style={{ width: "300px" }} />)}
                  </Form.Item>
                </div>
                <div style={{ paddingLeft: "9px" }}>
                  <Form.Item label="校区">
                    {this.props.form.getFieldDecorator("campus", {
                      rules: [{ required: true, message: '请输入校区' }],
                      initialValue: this.state.campus
                    })(
                      <Select style={{ width: "300px" }}>
                        <Select.Option key={0} value={0}></Select.Option>
                        <Select.Option key={1} value={1}>{'华山校HS'}</Select.Option>
                        <Select.Option key={2} value={2}>{'中星城校ZXC'}</Select.Option>
                        <Select.Option key={3} value={3}>{'时光里校SGL'}</Select.Option>
                        <Select.Option key={4} value={4}>{'晶耀前滩校JYC'}</Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                </div>
                {/*                          <div>
                            <Form.Item label="部门主管">
                              {this.props.form.getFieldDecorator('charge_user_name', {
                                rules: [{ required: true, message: '请输入部门主管' }],
                                initialValue: this.state.charge_user_name
                              })(<Input style={{width:"300px"}} />)}
                            </Form.Item>
                          </div>*/}
                {/* <div>
                <Form.Item label="部门主管">
                  {this.props.form.getFieldDecorator('charge_user_name', {
                    rules: [{ required: false, message: '请输入部门主管' }],
                    initialValue: this.state.charge_user_name
                  })( <Select mode="combobox"
                      style={{ width: "300px" }}
                      onChange={this.changeChargeUser}
                      filterOption={false}
                      placeholder="请输入持证人姓名"
                      onSelect={this.selectChargeUser}
                    >
                    {this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
                      this.props.employeeManagement.employeeList.Data.map(employee => {
                      return (
                        <Select.Option key={employee.id} value={employee.real_name}
                          data={employee.id} style={{width:"300px"}}>
                          {employee.real_name}
                        </Select.Option>)
                    })}
                    </Select>)}
                </Form.Item>
              </div> */}
                {/*                          <div>
                            <Form.Item label="副主管一">
                              {this.props.form.getFieldDecorator('charge_user_name_2', {
                                rules: [{ required: true, message: '请输入部门副主管一' }],
                                initialValue: this.state.charge_user_name_2
                              })(<Input style={{width:"300px"}} />)}
                            </Form.Item>
                          </div>
                          <div>*/}
                {/* <div>
                <Form.Item label="副主管一">
                  {this.props.form.getFieldDecorator('charge_user_name_2', {
                    rules: [{ required: false, message: '请输入副主管一' }],
                    initialValue: this.state.charge_user_name_2
                  })( <Select mode="combobox"
                      style={{ width: "300px" }}
                      onChange={this.changeChargeUser2}
                      filterOption={false}
                      placeholder="请输入持证人姓名"
                      onSelect={this.selectChargeUser2} >
                    {this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
                      this.props.employeeManagement.employeeList.Data.map(employee => {
                      return (
                        <Select.Option key={employee.id} value={employee.real_name}
                          data={employee.id} style={{width:"300px"}}>
                          {employee.real_name}
                        </Select.Option>)
                    })}
                    </Select>)}
                </Form.Item>
              </div> */}
                {/*                          <div>
                            <Form.Item label="副主管二">
                              {this.props.form.getFieldDecorator('charge_user_name_3', {
                                rules: [{ required: true, message: '请输入部门副主管二' }],
                                initialValue: this.state.charge_user_name_3
                              })(<Input style={{width:"300px"}} />)}
                            </Form.Item>
                          </div>*/}
                {/* <div>
                <Form.Item label="副主管二">
                  {this.props.form.getFieldDecorator('charge_user_name_3', {
                    rules: [{ required: false, message: '请输入副主管二' }],
                    initialValue: this.state.charge_user_name_3
                  })( <Select mode="combobox"
                      style={{ width: "300px" }}
                      onChange={this.changeChargeUser3}
                      filterOption={false}
                      placeholder="请输入持证人姓名"
                      onSelect={this.selectChargeUser3} >
                    {this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
                      this.props.employeeManagement.employeeList.Data.map(employee => {
                      return (
                        <Select.Option key={employee.id} value={employee.real_name}
                          data={employee.id} style={{width:"300px"}}>
                          {employee.real_name}
                        </Select.Option>)
                    })}
                    </Select>)}
                </Form.Item>
              </div> */}
                {/* <div style={{float:"none", width:"100%", overflow:"hidden"}}>
                            <Form.Item label="是否需要日报" style={{float:"left", width:"162px", marginLeft:"165px"}}>
                              {this.props.form.getFieldDecorator('write_daily_report', {
                                rules: [],
                                initialValue: this.state.selectDailyReport
                              })(<Checkbox style={{width:"40px"}} checked={this.state.selectDailyReport}
                              onClick={this.setSelectDailyReport} />)}
                            </Form.Item>
                            { this.state.selectDailyReport &&
                            <div style={{float:"left", width:"300px",paddingLeft:"10px"}}>
                              { this.state.dailyReportTemplate.map(template => {
                                return (
                                  <Form.Item label={template.name} key={template.id}>
                                    {this.props.form.getFieldDecorator(template.name, {
                                      rules: []
                                    })(<Radio name="dailyReport" setFieldsValue={template.id}
                                      checked={this.state.currentDailyReportTemplate === template.id}
                                      onClick={this.setDailyReportTemplate.bind(this, template.id)}/>)}
                                  </Form.Item>)
                              })}
                            </div>
                            }
                          </div>
                          
                          <div style={{float:"none", width:"100%", overflow:"hidden"}}>
                            <Form.Item label="是否需要周报" style={{float:"left", width:"162px", marginLeft:"165px"}}>
                              {this.props.form.getFieldDecorator('write_weekly_report', {
                                rules: [],
                                initialValue: this.state.selectWeeklyReport
                              })(<Checkbox style={{width:"40px"}} checked={this.state.selectWeeklyReport}
                                onClick={this.setSelectWeeklyReport} />)}
                            </Form.Item>
                            { this.state.selectWeeklyReport &&
                            <div style={{float:"left", width:"155px", paddingLeft:"10px"}}>
                              { this.state.weeklyReportTemplate.map(template => {
                                return (
                                  <Form.Item label={template.name} key={template.id}>
                                    {this.props.form.getFieldDecorator(template.name, {
                                      rules: []
                                    })(<Radio name="weeklyReport" setFieldsValue={template.id}
                                      checked={this.state.currentWeeklyReportTemplate === template.id}
                                      onClick={this.setWeeklyReportTemplate.bind(this, template.id)}/>)}
                                  </Form.Item>)
                              })}
                            </div>
                          }
                          </div>
                          
                          <div style={{float:"none", width:"100%", overflow:"hidden"}}>
                            <Form.Item label="是否需要月报" style={{float:"left", width:"162px", marginLeft:"165px"}}>
                              {this.props.form.getFieldDecorator('write_monthly_report', {
                                rules: [],
                                initialValue: this.state.selectMonthlyReport
                              })(<Checkbox style={{width:"40px"}} checked={this.state.selectMonthlyReport}
                                onClick={this.setSelectMonthlyReport} />)}
                            </Form.Item>
                            { this.state.selectMonthlyReport &&
                            <div style={{float:"left", width:"155px", paddingLeft:"10px"}}>
                              { this.state.monthlyReportTemplate.map(template => {
                                return (
                                  <Form.Item label={template.name} key={template.id}>
                                    {this.props.form.getFieldDecorator(template.name, {
                                      rules: []
                                    })(<Radio name="monthlyReport" setFieldsValue={template.id}
                                      checked={this.state.currentMonthlyReportTemplate === template.id}
                                      onClick={this.setMonthlyReportTemplate.bind(this, template.id)}/>)}
                                  </Form.Item>)
                              })}
                            </div>
                          }      
                          </div> */}

              </Form>
            </div>
          </Modal>
        }
        {/*                 {
                      employeeList ?
                          <DepartmentAddModal
                              title="新增部门"
                              visible={visible}
                              handleCreateNew={this.handleCreateNew}
                              handleCancel={this.handleCancel}
                              ref={this.saveFormRef}
                              users={users}
                              handleSearch={this.handleSearch}
                              employeeList={employeeList.Data}
                              // add={this.add}
                              // remove={this.remove}
                              // handleSubmit={this.handleSubmit}
                          />
                          :
                          ''
                  }*/}
        {/* 编辑当前部门 modal 弹窗 */}
        {
          departmentDetail && employeeList ?
            <DepartmentEditModal
              title="编辑部门"
              visible={editModalVisible}
              ref={this.saveEditFormRef}
              departmentDetail={departmentDetail.department}
              users={users}
              handleUpdate={this.handleUpdate}
              handleCancel={this.handleCancelEditModal}
              isFirstInputDisabled={isDisabled}
              employeeList={employeeList.Data}
            />
            :
            ''
        }
        {
          departmentsList ?
            <DepartmentMoveModal
              title="合并部门"
              treeData={departmentsList}
              visible={moveModalVisible}
              handleCancel={this.handleCancelMoveModal}
              handleUpdate={this.handleMoveDepartment}
              onSelectTreeNode={this.onSelectTreeNode}
              defaultExpandedKeys={expandedRowKey}
            />
            :
            ''
        }
      </div>
    )
  }
}
DepartmentStructure = Form.create()(DepartmentStructure);
DepartmentStructure = LayoutWrapper(DepartmentStructure);
export default DepartmentStructure;



// WEBPACK FOOTER //
// ./src/routes/DepartmentStructure/DepartmentStructure.js